import React , {useState, useEffect } from 'react';
import {  useLocation, useNavigate, useParams } from 'react-router-dom';
import PageTitle from '../components/pagetitle/PageTitle2';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import avtd6 from '../assets/images/contactIcon/address.png'
import Data from '../assets/data/data-perintis'


import avtd3 from '../assets/images/contactIcon/mail.png'
import avtd4 from '../assets/images/contactIcon/profile.png'
import avtd5 from '../assets/images/contactIcon/tel.png'
import DefaultImage from "../assets/images/logo/logo_dark.png"

import DefaultImageKempen from "../assets/images/kempenDefault.jpg"

import PageLoader from '../components/loading/PageLoader'
import { API_URL, CP_API_URL } from '../config/api'
import './institusiDetaisl.scss'

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';


InstitusiDetaisl.propTypes = {
    
};

function InstitusiDetaisl(props) {

    const { slug }                                                          = useParams();
    const [itemData, setItemData]                                           = useState(null);
    const navigate                                                          = useNavigate()
    const state                                                             = useLocation().state

    const [activeTabIndex, setActiveTabIndex]                               = useState(0);

    const [nama_masjid, set_nama_masjid]                                    = useState("")
    const [org_code, set_org_code]                                          = useState("")
    const [gambar_masjid, set_gambar_masjid]                                = useState("")
    const [alamat_masjid, set_alamat_masjid]                                = useState("")
    const [bandar_masjid, set_bandar_masjid]                                = useState("")
    const [email_masjid, set_email_masjid]                                  = useState("")
    const [emailpic_masjid, set_emailpic_masjid]                            = useState("")
    const [namepic_masjid, set_namepic_masjid]                              = useState("")
    const [nomborpic_masjid, set_nomborpic_masjid]                          = useState("")
    const [phone_masjid, set_phone_masjid]                                  = useState("")
    const [description_masjid, set_description_masjid]                      = useState([])

    const [senarai_hebahan, set_senarai_hebahan]                            = useState([])
    const [senarai_kempen, set_senarai_kempen]                              = useState([])
    const [senarai_ajk, set_senarai_ajk]                                    = useState([])

    const [loading, setLoading]                                             = useState(true)



    const DETAILS_MASJID = async () => {
        const requestOptions = {
            method: "GET",
            redirect: "follow"
          };
          
          await fetch(`${API_URL}/portal/senarai-institusi/${state.organizationId}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                //console.log("Details Institusi",result)
                let { 
                    organizationName, 
                    organizationImage, 
                    organizationAddress,
                    organizationCity,
                    organizationEmail,
                    organizationPICEmail,
                    organizationPICName,
                    organizationPICPhone,
                    organizationPhone,
                    organizationPostcode,
                    organizationState,
                    organizationData,
                    organizationCode
                    
                    
                } = result.data[0]
                set_nama_masjid(organizationName)
                set_gambar_masjid(organizationImage)
                set_alamat_masjid(organizationAddress)
                set_bandar_masjid(organizationCity)
                set_email_masjid(organizationEmail)
                set_emailpic_masjid(organizationPICEmail)
                set_namepic_masjid(organizationPICName)
                set_nomborpic_masjid(organizationPICPhone)
                set_phone_masjid(organizationPhone)
                set_description_masjid(organizationData)
                set_org_code(organizationCode)
            })
            
            .catch((error) => console.error(error));
    }

    const LIST_HEBAHAN = async () => {
        const requestOptions = {
            method: "GET",
            redirect: "follow",
        };
    
        await fetch(`${CP_API_URL}/getHebahan?orgId=${state.organizationId}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                //console.log("List Hebahan: ", result);
                const activeHebahan = result.data.filter(item => item.HEB_STATUS === "Active");
                set_senarai_hebahan(activeHebahan);
            })
            .catch((error) => console.error(error));
    };
    
    

    const LIST_KEMPEM = async () => {
        const requestOptions = {
            method: "GET",
            redirect: "follow"
          };
          
          
          await fetch(`${CP_API_URL}/getKempen?orgId=${state.organizationId}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
                //console.log("List Kempen: ",result)
                const activeKempen = result.data.filter(item => item.campaignStatus === "ACTIVE");
                set_senarai_kempen(activeKempen)
            })
            
            .catch((error) => console.error(error));
    }

    const rolePriority = {
        "Pengerusi": 1,
        "Timbalan Pengerusi": 2,
        "Nazir": 3,
        "Timbalan Nazir": 4,
        "Setiausaha": 5,
        "Bendahari": 6,
        "Imam 1": 7,
        "Imam 2": 8,
        "Imam 3": 9,
        "Imam 4": 10,
        "Imam 5": 11,
        "Bilal 1": 12,
        "Bilal 2": 13,
        "Bilal 3": 14,
        "Bilal 4": 15,
        "Siak 1": 16,
        "Siak 2": 17,
        "Penasihat Agama": 18,
        "Penasihat Am": 19,
        "Pemeriksa Kira-Kira 1": 20,
        "Pemeriksa Kira-Kira 2": 21,
        "AJK 1": 22,
        "AJK 2": 23,
        "AJK 3": 24
    };

    const LIST_AJK = async () => {
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };
        
        await fetch(`${CP_API_URL}/getSubUsersByOrganization?orgId=${state.organizationId}`, requestOptions)
            .then((response) => response.json())
            .then((result) => {
    
                const roleOrder = ["Pengerusi","Timbalan Pengerusi","Nazir","Timbalan Nazir","Setiausaha","Bendahari","Imam 1","Imam 2","Imam 3","Imam 4","Imam 5","Bilal 1","Bilal 2","Bilal 3","Bilal 4","Siak 1","Siak 2","Penasihat Agama","Penasihat Am","Pemeriksa Kira-Kira 1","Pemeriksa Kira-Kira 2","AJK 1","AJK 2","AJK 3"];
    
                const activeAJK = result.data
                    .filter(item => item.AjkStatus === "Active")
                    .sort((a, b) => roleOrder.indexOf(a.role) - roleOrder.indexOf(b.role));

                    //console.log("List AJK Active",activeAJK);
    
                set_senarai_ajk(activeAJK);
            })
            .catch((error) => console.error(error));
    };
    
    
    
    useEffect(() => {
        const loadInstitusiData = async () => {
            setLoading(true)
            await Promise.all([
                DETAILS_MASJID(),
                LIST_HEBAHAN(),
                LIST_AJK(),
                LIST_KEMPEM()
            ])
            setLoading(false)
        }

        loadInstitusiData()
    }, [])

    

    useEffect(() => {
        //console.log('useEffect triggered');
        const itemData = Data.find((item) => item.slug === slug);
        //console.log(itemData);
        setItemData(itemData);
      }, [slug]);
    
    //   if (!itemData) {
    //     return <div>{JSON.stringify(state)}</div>;
    //   }

    const getInitial = (name) => {
        if (!name || typeof name !== 'string') return '?'
        return name.trim().charAt(0).toUpperCase()
    }

    if (loading) {
        return (
            <div className="id-page">
                <PageTitle sub='Senarai Institusi' title='Maklumat Institusi' />
                <PageLoader text='Sedang memuatkan maklumat institusi...' />
            </div>
        )
    }

    return (
        <div className="id-page">

            <PageTitle sub='Senarai Institusi' title='Maklumat Institusi' />

            <section className="id-hero">
                <div className="tf-container">
                    <div className="id-hero-media">
                        <img
                            src={gambar_masjid ? gambar_masjid : DefaultImage}
                            alt={nama_masjid || "AlJariyah"}
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = DefaultImage;
                            }}
                        />
                    </div>

                    <div className="id-hero-info">
                        <h1 className="id-hero-title">{nama_masjid}</h1>
                        {bandar_masjid && (
                            <p className="id-hero-location">
                                <i className="fas fa-map-marker-alt"></i>
                                {bandar_masjid}
                            </p>
                        )}
                    </div>
                </div>
            </section>

            <section className="id-content">
                <div className="tf-container">
                    <Tabs className="id-tabs" selectedIndex={activeTabIndex} onSelect={(index) => setActiveTabIndex(index)}>
                        <TabList className="id-tab-list">
                            <Tab>Maklumat</Tab>
                            <Tab>Pegawai Untuk Dihubungi</Tab>
                            <Tab>Alamat</Tab>
                        </TabList>

                        <TabPanel>
                            <div className="id-panel">
                                {description_masjid && JSON.parse(description_masjid).length > 0 ? (
                                    JSON.parse(description_masjid).map((data, index) => (
                                        <div key={index} className="id-info-row">
                                            <h6 className="id-info-title">
                                                {data.title ?? '-- tiada maklumat --'}
                                            </h6>
                                            <p className="id-info-value">
                                                {data.data ?? '-- tiada maklumat --'}
                                            </p>
                                        </div>
                                    ))
                                ) : (
                                    <p className="id-empty">Tiada Rekod</p>
                                )}
                            </div>
                        </TabPanel>

                        <TabPanel>
                            <div className="id-panel id-contact-grid">
                                <div className="id-contact-card">
                                    <span className="id-contact-icon">
                                        <img src={avtd4} alt="Nama Pegawai" />
                                    </span>
                                    <div>
                                        <p className="id-contact-label">Nama Pegawai</p>
                                        <p className="id-contact-value">{namepic_masjid ?? '-- tiada maklumat --'}</p>
                                    </div>
                                </div>
                                <div className="id-contact-card">
                                    <span className="id-contact-icon">
                                        <img src={avtd5} alt="Nombor Telefon" />
                                    </span>
                                    <div>
                                        <p className="id-contact-label">Nombor Telefon</p>
                                        <p className="id-contact-value">{nomborpic_masjid ?? '-- tiada maklumat --'}</p>
                                    </div>
                                </div>
                                <div className="id-contact-card">
                                    <span className="id-contact-icon">
                                        <img src={avtd3} alt="E-mel" />
                                    </span>
                                    <div>
                                        <p className="id-contact-label">E-mel</p>
                                        <p className="id-contact-value">{emailpic_masjid ?? '-- tiada maklumat --'}</p>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>

                        <TabPanel>
                            <div className="id-panel id-contact-grid">
                                <div className="id-contact-card">
                                    <span className="id-contact-icon">
                                        <img src={avtd6} alt="Alamat" />
                                    </span>
                                    <div>
                                        <p className="id-contact-label">{bandar_masjid ?? '-- tiada maklumat --'}</p>
                                        <p className="id-contact-value">{alamat_masjid ?? '-- tiada maklumat --'}</p>
                                    </div>
                                </div>
                            </div>
                        </TabPanel>
                    </Tabs>
                </div>
            </section>

            <section className="id-section">
                <div className="tf-container">
                    <div className="id-section-head">
                        <h5 className="id-section-title">Senarai Ahli Jawatankuasa</h5>
                    </div>

                    {!senarai_ajk || senarai_ajk.length === 0 ? (
                        <p className="id-empty">Tiada Rekod</p>
                    ) : (
                        <div className="id-ajk-grid">
                            {senarai_ajk.map((jawatan, idx) => (
                                <div key={idx} className="id-ajk-card">
                                    <div className="id-ajk-avatar">{getInitial(jawatan.username)}</div>
                                    <p className="id-ajk-role">{jawatan.role}</p>
                                    <p className="id-ajk-name">{jawatan.username}</p>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </section>

            <section className="id-section">
                <div className="tf-container">
                    <div className="id-section-head">
                        <h5 className="id-section-title">Hebahan Institusi</h5>
                    </div>

                    {!senarai_hebahan || senarai_hebahan.length === 0 ? (
                        <p className="id-empty">Tiada Rekod</p>
                    ) : (
                        <div className="id-carousel">
                            <Swiper
                                modules={[Navigation, Pagination, Scrollbar, A11y]}
                                spaceBetween={24}
                                slidesPerView={3}
                                navigation
                                pagination={{ clickable: true }}
                                breakpoints={{
                                    1024: {
                                        slidesPerView: 3,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                    },
                                    0: {
                                        slidesPerView: 1,
                                    },
                                }}
                            >
                                {senarai_hebahan.map((newsItem, idx) => (
                                    <SwiperSlide key={idx}>
                                        <div className="id-news-card">
                                            <div className="id-news-media">
                                                <img
                                                    src={newsItem.HEB_IMAGE}
                                                    alt={newsItem.HEB_TITLE}
                                                />
                                            </div>
                                            <div className="id-news-body">
                                                <h6 className="id-news-title">{newsItem.HEB_TITLE}</h6>
                                                <p className="id-news-desc">{newsItem.HEB_DESCRIPTION}</p>
                                                <button
                                                    className="id-news-link"
                                                    onClick={() =>
                                                        navigate(`/institusi/hebahan/${newsItem.HEB_TITLE.trim().replace(/\s/g, "-")}`, { state: newsItem })
                                                    }
                                                >
                                                    Maklumat Lanjut
                                                    <i className="fas fa-arrow-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    )}
                </div>
            </section>

            <section className="id-section" style={{ borderBottom: 'none', paddingBottom: '100px' }}>
                <div className="tf-container">
                    <div className="id-section-head">
                        <h5 className="id-section-title">Kempen Institusi</h5>
                    </div>

                    {!senarai_kempen || senarai_kempen.length === 0 ? (
                        <p className="id-empty">Tiada Rekod</p>
                    ) : (
                        <div className="id-carousel">
                            <Swiper
                                modules={[Navigation, Pagination, Scrollbar, A11y]}
                                spaceBetween={24}
                                slidesPerView={3}
                                navigation
                                pagination={{ clickable: true }}
                                breakpoints={{
                                    1024: {
                                        slidesPerView: 3,
                                    },
                                    768: {
                                        slidesPerView: 2,
                                    },
                                    0: {
                                        slidesPerView: 1,
                                    },
                                }}
                            >
                                {senarai_kempen.map((kempenItem, idx) => (
                                    <SwiperSlide key={idx}>
                                        <div className="id-news-card">
                                            <div className="id-news-media">
                                                <img
                                                    src={kempenItem.campaignImage ? kempenItem.campaignImage : DefaultImageKempen}
                                                    alt={kempenItem.campaignTitle}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = DefaultImageKempen;
                                                    }}
                                                />
                                            </div>
                                            <div className="id-news-body">
                                                <h6 className="id-news-title">{kempenItem.campaignTitle}</h6>
                                                <p className="id-news-desc">Sasaran Kutipan: RM {kempenItem.campaignTarget}</p>
                                                <button
                                                    className="id-news-link"
                                                    // onClick={() => navigate(`/institusi/kempen?orgCode=${org_code}&campaignId=${kempenItem.campaignId}&campaignCode=${kempenItem.campaignCode}`, { state: kempenItem })}
                                                    onClick={() => navigate(`/institusi/${org_code}/kempen/${kempenItem.campaignCode}`, { state: kempenItem })}
                                                >
                                                    Maklumat Lanjut
                                                    <i className="fas fa-arrow-right"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}

export default InstitusiDetaisl;